import axiosIns from '@/libs/axios'

export default orderId => axiosIns.post(`/order/${orderId}/optimize-route`)
